module.exports = __webpack_public_path__ + "img/T4-D-rc_14.75e64fe9.png";